import React from 'react';
import $ from 'jquery';
import 'bootstrap';

export default class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      processing: false,
      processingMessage: '',
      error: false,
      errorMessage: '',
    };

    this.create = this.create.bind(this);
  }

  create() {
    this.setState({ error: false, errorMessage: '' });
    if (!$(this.appName).val()) {
      this.setState({ error: true, errorMessage: 'You must provide an app name' });
      return;
    }
    this.setState({ errorNoAppName: false });
    this.props.qGlobal.getDocList().then((docList) => {
      const docs = docList.map(doc => doc.qDocName);
      if (docs.includes($(this.appName).val())) {
        this.setState({ error: true, errorMessage: 'An app with that name already exists' });
        return;
      }
      this.setState({ processing: true, processingMessage: 'Creating project...' });
      this.props.qGlobal.createApp($(this.appName).val()).then((reply) => {
        this.props.qGlobal.copyApp(reply.qAppId, '48b82e3b-4ae4-4e51-82ea-c13735126e14', []).then(() => {
          this.setState({ processingMessage: 'Taking you to the hub...' });
          setTimeout(() => {
            window.location = 'https://calculators.qlik.com/sso/hub/my/work';
          }, 2000);
        });
      }).catch(() => {
        this.setState({ processing: false, error: true, errorMessage: 'There was an error saving the app' });
      });
    });
  }

  render() {
    return (
      <div className="main-component">
        <div className="bg-primary text-light py-5 d-flex align-items-center" style={{ position: 'relative', overflow: 'hidden', minHeight: '600px' }}>
          <img src="assets/circles.png" style={{ position: 'absolute', top: '-1%', right: '-1%', width: '35%' }} />
          <div className="container" style={{ position: 'relative' }}>
            <div>
              <a href="https://www.qlik.com" target="_blank"><img src="assets/qlik-logo.png" /></a>
            </div>
            <div className="py-7 relative" style={{ maxWidth: '600px' }}>
              <h1>ROI Calculator</h1>
              <p>Welcome to the Qlik ROI Calculator! This ROI Calculator helps you calculate the value that an investment in Qlik will bring to an organization. The calculator uses Qlik’s powerful yet flexible out-of-the-box computational & visualization functionality to model discounted cash-flows (costs-benefits) over 5 years, calculate typical ROI measures like IRR, NPV, Payback, etc., and run scenarios, Monte Carlo simulations, and interactive presentations.</p>
              <div className="row mt-5" style={{ display: this.props.permission ? null : 'none' }}>
                <div className="col mr-5">
                  <h3>Create new project</h3>
                  <div className={`form-group ${this.state.processing ? 'hidden' : null}`}>
                    <label htmlFor="appNameInput">Project name</label>
                    <input type="text" className="form-control" id="appNameInput" ref={(c) => { this.appName = c; }} placeholder="Project name" />
                  </div>
                  <button className={`btn btn-primary border border-light ${this.state.processing ? 'hidden' : null}`} onClick={this.create}>Create</button>
                  <div className={`alert alert-danger fade show mt-3 absolute fullwidth ${this.state.error ? null : 'hidden'}`} role="alert" ref={(c) => { this.alert = c; }}>
                    {this.state.errorMessage}
                  </div>
                  <div className={`d-flex justify-content-center align-items-center bg-primary text-light fullscreen overlay ${this.state.processing ? null : 'hidden'}`}>
                    {this.state.processingMessage}
                  </div>
                </div>
                <div className="col">
                  <h3>View existing projects</h3>
                  <a className="btn btn-primary border border-light" href="https://calculators.qlik.com/sso">Go to hub</a>
                </div>
              </div>
              <div className="row mt-5" style={{ display: this.props.permission ? 'none' : null }}>
                You do not have permission to access the Qlik ROI Calculator
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Main/index.js